import { Provider } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import "./App.css";
import store, { persistor } from "./store/store";
import AuthProvider from "./services/auth/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Router from "./routes";
import { ThemeProvider } from "./ThemeContext";
import "./styles.scss";
import { PersistGate } from "redux-persist/integration/react";
import NotificationManager from './components/notifications/NotificationManager';
import ErrorBoundary from "./ErrorBoundary"; // 👈 added

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AuthProvider>
            <ThemeProvider>
              <CssBaseline />
              <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
              <NotificationManager />
              <Router />
            </ThemeProvider>
          </AuthProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
